export default ({request}) => ({
  ecomCompanyListApi(data = {}) {
    return request({
      url: '/ecom/ecomCompany/list',
      method: 'post',
      data,
    })
  },
  ecomCompanyDetailApi(data = {}) {
    return request({
      url: '/ecom/ecomCompany/detail',
      method: 'post',
      data,
    })
  },
  ecomCompanySaveApi(data = {}) {
    return request({
      url: '/ecom/ecomCompany/save',
      method: 'post',
      data,
    })
  },
  ecomCompanyDelApi(data = {}) {
    return request({
      url: '/ecom/ecomCompany/del',
      method: 'post',
      data,
    })
  },
})
